export const CHECKOUT_BOOKING = "CHECKOUT_BOOKING"
export const FETCH_PAGE = "FETCH_PAGE"